import { shouldUseMocks } from './mockApi'
import * as mock from './mockApi/messagesApi'
import { patientGet, patientPost } from './patientApi'

const BASE = '/api/secure/me/messages'
const CTX = { requirePatientContext: true }

export async function listThreads(profile) {
  if (shouldUseMocks()) return mock.listThreads(profile)
  const res = await patientGet(`${BASE}/threads`, CTX)
  return res?.data || []
}

export async function getThread(profile, peerId, page = 1, pageSize = 30) {
  if (shouldUseMocks()) return mock.getThread(profile, peerId, page, pageSize)
  const res = await patientGet(
    `${BASE}/threads/${encodeURIComponent(peerId)}`,
    { ...CTX, params: { page, pageSize } },
  )
  return res?.data || { items: [] }
}

export async function send(profile, peerId, body) {
  if (shouldUseMocks()) return mock.send(profile, peerId, body)
  const res = await patientPost(`${BASE}/threads/${encodeURIComponent(peerId)}/send`, body, CTX)
  return res?.data
}

export async function markRead(profile, peerId) {
  if (shouldUseMocks()) return mock.markRead(profile, peerId)
  await patientPost(`${BASE}/threads/${encodeURIComponent(peerId)}/read`, null, CTX)
}

export async function unreadCount(profile) {
  if (shouldUseMocks()) return mock.unreadCount(profile)
  const res = await patientGet(`${BASE}/unread-count`, CTX)
  return res?.data || { messages: 0, notifications: 0 }
}
